
import { useState } from 'react';
import { Button } from '../base/Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/554888397243?text=Olá! Quero conhecer os serviços da Aura Estética Automotiva.', '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0D0D0D]/95 backdrop-blur-sm border-b border-gray-800">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/23e6e82711d555609e11a3dec8506ccb/b56242dfe0d6ad4740b3bcc4ba25f998.png" 
              alt="Aura Estética Automotiva" 
              className="h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium cursor-pointer"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('servicos')}
              className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium cursor-pointer"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('galeria')}
              className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium cursor-pointer"
            >
              Galeria
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium cursor-pointer"
            >
              Contato
            </button>
            <button
              onClick={handleWhatsApp}
              className="bg-[#C8A45D] hover:bg-[#D4B76A] text-black font-medium px-4 py-2 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Agendar
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white hover:text-[#C8A45D] transition-colors duration-300 cursor-pointer"
          >
            <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-800">
            <div className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium text-left cursor-pointer"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('servicos')}
                className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium text-left cursor-pointer"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('galeria')}
                className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium text-left cursor-pointer"
              >
                Galeria
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="text-white hover:text-[#C8A45D] transition-colors duration-300 font-medium text-left cursor-pointer"
              >
                Contato
              </button>
              <button
                onClick={handleWhatsApp}
                className="bg-[#C8A45D] hover:bg-[#D4B76A] text-black font-medium px-4 py-2 rounded-lg transition-colors duration-300 text-left whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Agendar
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
